import {
  parseObjectForGraphql,
  parseMultiSelectCheckboxForGQL,
} from "../helper";

const updateQueryBuilder = (formType, id, data, formData) => {
  let name;
  let Input = {};
  if (formType === "employer") {
    name = "Employer";
  } else if (formType === "agent-attorney") {
    name = "AgentProfile";
  } else if (formType === "foreign-labor") {
    name = "Recruiter";
    Input.form_id = "recruiter";
  } else if (formType === "employer-pocs") {
    name = "POC";
    Input.employer_id = data[`get${name}ById`].employer_id;
  } else if (formType === "agent-attorney-individs") {
    name = "Agent";
    Input.form_id = "Agent";
    Input.agent_id = data[`get${name}ById`].agent_id;
  } else if (formType === "crop") {
    name = "Crop";
    Input.form_id = "Crop";
  } else if (formType === "worker-housing") {
    name = "WorkerHousing";
    Input.form_id = "WorkerHousing";
  } else if (formType === "agriculture") {
    name = "Agriculture";
    Input.form_id = "Agriculture";
  } else if (formType === "material-terms") {
    name = "MaterialTerms";
    Input.form_id = "MaterialTerms";
  } else if (formType === "foreign-worker") {
    name = "ForeignWorker";
    Input.form_id = "ForeignWorker";
  } else if (formType === "foreign-worker-group") {
    name = "ForeignWorkerGroup";
    Input.form_id = "ForeignWorkerGroup";
  }

  Input.group_id = data[`get${name}ById`].group_id;
  Input.user_id = data[`get${name}ById`].user_id;
  if (
    formType === "crop" ||
    formType === "agriculture" ||
    formType === "worker-housing" ||
    formType === "material-terms" ||
    formType === "foreign-worker" ||
    formType === "foreign-worker-group"
  ) {
    delete Input.user_id;
  }
  if (data[`get${name}ById`].form_id) {
    Input.form_id = data[`get${name}ById`].form_id;
  }

  if (formType === "foreign-worker-group") {
    delete formData.new_group_fw_num_profiles;
  }

  // remove key value pairs where value is null
  // this happens in cases where either state or province
  // is sent, but not both fields
  Object.keys(formData).map((key) => {
    if (formData[key] === null) {
      delete formData[key];
      return "";
    } else if (Array.isArray(formData[key])) {
      for (const x of formData[key]) {
        Object.keys(x).map((keys) => {
          if (x[keys] === null) {
            delete x[keys];
            return "";
          }
        });
      }
    }
  });

  // For MultiSelect CheckList
  if (formType === "worker-housing") {
    parseMultiSelectCheckboxForGQL(formData);
  }
  let EInput = parseObjectForGraphql(Input);
  let EFormData = parseObjectForGraphql(formData);

  const query = `mutation  {
    update${name}ById(id:"${id}",${name}Input:{${EInput}}, ${name}FormData:{${EFormData}}
    )}
      `;
  return query;
};

export default updateQueryBuilder;
